export default {
  data: function() {
    return {
      // Default data
      termsData: [
        { name: '36 months', value: 36, default: false },
        { name: '48 months', value: 48, default: false },
        { name: '60 months', value: 60, default: true },
        { name: '72 months', value: 72, default: false }
      ],

      // Terms drop-down
      termsDataDefaultOptions: [],
      termsItems: [],
      termsItemsSelected: [],

      // Info
      termsDataInfo: [
        { copy: 'The amount of time until the auto loan matures.' }
      ]
    }
  }
}
